import {useQuery} from "react-query";
import {filterFetch} from "../../../fetch-api/get";
import {useMainContext} from "../../../../contexts/main";
import {makeQueryFilters} from "../../../../utils/query-maker";


const ADDRESS_KEYS = {
    FETCH_ADDRESSES: 'fetch-addresses'
}


const useGetAddresses = (filters, pagination) => {

    const { lang } = useMainContext()
    const params = {...makeQueryFilters(filters, lang), ...pagination}

    return useQuery(
        ADDRESS_KEYS.FETCH_ADDRESSES, () => filterFetch(params, 'addresses/admin')
    )
}


export {
    useGetAddresses
}
